import { c as _c } from "react/compiler-runtime";
import React, { ComponentProps, ForwardedRef } from 'react';
import { prepareProps } from '../../utils/propUtils';
import { classes } from '../../utils/utils';
import { DropdownListItem } from '../DropdownListItem/DropdownListItem';
import styles from './DropdownList.module.css';
export type DropdownListProps<T> = ComponentProps<'div'> & {
  readonly items: Array<T>;
  readonly highlightedItem?: T;
  readonly getDisplayTextOfItem: (item: T) => string;
  readonly getKeyOfItem: (item: T, index: number) => string;
  readonly onItemSelected: (item: T) => void;
};
export const DropdownList = React.memo(props => {
  const $ = _c(10);
  let t0;
  let t1;
  let t2;
  let t3;
  if ($[0] !== props) {
    const {
      items,
      highlightedItem,
      getDisplayTextOfItem,
      getKeyOfItem,
      onItemSelected,
      className,
      ref,
      ...remainingProps
    } = prepareProps({
      props,
      ignoreChildren: true
    });
    t0 = ref;
    t1 = remainingProps;
    t2 = classes(className, styles.list);
    t3 = items.map((item, index) => <DropdownListItem item={item} highlighted={item === highlightedItem} getDisplayTextOfItem={getDisplayTextOfItem} key={getKeyOfItem(item, index)} onItemSelected={onItemSelected} data-testid="DropdownList.Item" />);
    $[0] = props;
    $[1] = t0;
    $[2] = t1;
    $[3] = t2;
    $[4] = t3;
  } else {
    t0 = $[1];
    t1 = $[2];
    t2 = $[3];
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t0 || $[6] !== t1 || $[7] !== t2 || $[8] !== t3) {
    t4 = <div ref={t0} {...t1} className={t2}>{t3}</div>;
    $[5] = t0;
    $[6] = t1;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
}) as <T>(props: DropdownListProps<T> & {
  ref?: ForwardedRef<HTMLDivElement>;
}) => React.JSX.Element;